export default __webpack_public_path__ + "static/media/whychooseicon6.1668e32d.png";